var map = {
	"./card-aboniment-2.jpg": 2892,
	"./card-building-2.jpg": 8268,
	"./card-cleaning-2.jpg": 7100,
	"./card-flowers-2.jpg": 1720,
	"./card-grass-2.jpg": 3524,
	"./card-monument-2.jpg": 6356,
	"./card-monument-restouration-2.jpg": 1240,
	"./card-restouration-2.jpg": 3824,
	"./card-sand-2.jpg": 7388,
	"./carousel-2.jpg": 1236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6180;